

import { Injectable } from '@angular/core';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { SyncStorageHandler } from '@mainrepo/app/core/database/SyncStorageManager';
import { SessionStorageService } from 'angular-web-storage';

@Injectable({
  providedIn: 'root'
})


export class LocalStorageSvc {

  syncStorageHandler: SyncStorageHandler;
  constructor(
 
    public sessionStorage:SessionStorageService
  ) {
    this.syncStorageHandler = new SyncStorageHandler();
  }

  private setItem(key, value, toEncrypt: boolean = false) {

    if (toEncrypt) {
      this.syncStorageHandler.setLocalProperty(key, value)
    } else {
      localStorage.setItem(key, value)
    } 
  }

  private getItem(key, isEncrypted: boolean = false) {
    if (isEncrypted) {
      return this.syncStorageHandler.getLocalProperty(key)
    } else {
      return localStorage.getItem(key)
    } 
  }

  private removeItem(key) {
     localStorage.removeItem(key)
  }

  public getDCGroupCode(isEncrypted?:boolean) {
    return this.getItem(LocalStorageProps.DC_GROUP_CODE, isEncrypted);
  }

  public getUserData(isEncrypted?:boolean) {
    return this.getItem(LocalStorageProps.JIO, isEncrypted);
  }

  public gettokenRefreshedTime(isEncrypted?:boolean) {
    return this.getItem(LocalStorageProps.LAST_REFRESH_TIME, isEncrypted) ;
  }

  public imageExists(isEncrypted?:boolean){
    return this.getItem(LocalStorageProps.IMGEXISTS, isEncrypted);
  }

  public audiosExists(isEncrypted?:boolean){
    return this.getItem(LocalStorageProps.AUDIOSEXIST, isEncrypted);
  }

  public videosExists(isEncrypted?:boolean){
    return this.getItem(LocalStorageProps.VIDEOS_EXIST, isEncrypted) ;
  }

  public othersExists(isEncrypted?:boolean){
    return this.getItem(LocalStorageProps.OTHERS_EXIST, isEncrypted) ;
  }

  public getCurrentFolder(isEncrypted?:boolean){
    return this.getItem(LocalStorageProps.SHARED_FOLDER, isEncrypted) ;
  }

  public getSharedFolder(isEncrypted?:boolean){
    return this.getItem(LocalStorageProps.SHARED_FOLDER, isEncrypted) ;
  }

  public getReferralCodeDetails(isEncrypted?:boolean){
    return this.getItem(LocalStorageProps.REFERRAL_DETAILS, isEncrypted) ;
  }

  public setReferralCodeDetails(val, toEncrypt:boolean = false){
    this.setItem(LocalStorageProps.REFERRAL_DETAILS, val, toEncrypt);
  }

  public setImageExists(currentKey, toEncrypt?){
    this.setItem(LocalStorageProps.IMGEXISTS, currentKey, toEncrypt);
  }

  public setAudiosExists(currentKey, toEncrypt?){
    this.setItem(LocalStorageProps.AUDIOSEXIST, currentKey, toEncrypt);
  }
  public setVideosExists(currentKey, toEncrypt?){
    this.setItem(LocalStorageProps.VIDEOS_EXIST, currentKey, toEncrypt);
  }
  public setOthersExists(currentKey, toEncrypt?){
    this.setItem(LocalStorageProps.OTHERS_EXIST, currentKey, toEncrypt);
  }

  public setSharedFolder(folder, toEncrypt?){
    this.setItem(LocalStorageProps.SHARED_FOLDER, folder, toEncrypt);
  }

  public setDcGroupCode(data, toEncrypt?) {
    this.setItem(LocalStorageProps.DC_GROUP_CODE, data, toEncrypt);
  }

  public setUserData(data, toEncrypt?) {
    this.setItem(LocalStorageProps.JIO, data, toEncrypt);
  }

  public setRefreshTokenTime(data, toEncrypt?) {
    this.setItem(LocalStorageProps.LAST_REFRESH_TIME, data, toEncrypt);
  }
  
  public removeLocalProperty(property){
    localStorage.removeItem(property);
  }

  public setNativeHeaders(property,data){
    this.setItem(property,data,true)
  }

  public getNativeHeaders(property){
    return this.getItem(property,true)
  }

  public setInviteKey(property,key){
    return this.setItem(property,key,true)
  }

  public setTwoFAEnable(data,toEncrypt?){
    this.setItem(LocalStorageProps.TWOFA_ENABLED, data, toEncrypt);
  }

  public getInviteKey(property){
    return (this.getItem(property,true) == undefined || this.getItem(property,true) == null)? "" : this.getItem(property,true)
  }
    
  public getTwoFAEnable(isEncrypted?){
    return this.getItem(LocalStorageProps.TWOFA_ENABLED,isEncrypted);
  }

  public getLastUserMovementTime(isEncrypted?){
    return this.getItem(LocalStorageProps.MOVEMENT_TIME,isEncrypted);
  }

  public setLastUserMovementTime(data,toEncrypt?){
    this.setItem(LocalStorageProps.MOVEMENT_TIME, data, toEncrypt);

  }
  public setSearchKey(property,data){ // set the search key in local storage if the user is navigating from result page inside a folder
    return this.setItem(property,data,true)
  }

  public getSearchKey(property){
    return (this.getItem(property,true) == undefined || this.getItem(property,true) == null)? "" : this.getItem(property,true)
  }

  public removeSearchKey(){
    this.removeItem(LocalStorageProps.SEARCH_KEY);
  }

  public setRecoverData(recoverData,toEncrypt?){
    this.setItem(LocalStorageProps.RECOVER_DATA, recoverData, false)
  }

  public getRecoverData(isEncrypted?:boolean){
    return this.getItem(LocalStorageProps.RECOVER_DATA, false);
  }

  public setRecoverDataMobile(recoverDataMobile,toEncrypt?){
    this.setItem(LocalStorageProps.RECOVER_DATA_MOBILE, recoverDataMobile, false)
  }

  public getRecoverDataMobile(isEncrypted?:boolean){
    return this.getItem(LocalStorageProps.RECOVER_DATA_MOBILE, false);
  }

  public setRecoverDataError(recoverDataError,toEncrypt?){
    this.setItem(LocalStorageProps.RECOVER_DATA_ERROR, recoverDataError, false)
  }

  public getRecoverDataError(isEncrypted?:boolean){
    return this.getItem(LocalStorageProps.RECOVER_DATA_ERROR, false);
  }


  public setInviteData(data,toEncrypt?){
    this.setItem(LocalStorageProps.FAMILY_SHARE_INVITE_DATA, data, true);
  }

  public getInviteData(isEncrypted?:boolean){
    return this.getItem(LocalStorageProps.FAMILY_SHARE_INVITE_DATA, true);
  }

  public setBannerDetails(data,toEncrypt?){
    this.setItem(LocalStorageProps.BANNER_DETAILS, data, true);
  }

  public getBannerDetails(toEncrypt?){
    return this.getItem(LocalStorageProps.BANNER_DETAILS, true);
  }


  public setShareImageExists(currentKey, toEncrypt?){
    this.setItem(LocalStorageProps.SHARE_IMGEXISTS, currentKey, toEncrypt);
  }

  public setShareAudiosExists(currentKey, toEncrypt?){
    this.setItem(LocalStorageProps.SHARE_AUDIOSEXIST, currentKey, toEncrypt);
  }

  public setShareVideosExists(currentKey, toEncrypt?){
    this.setItem(LocalStorageProps.SHARE_VIDEOS_EXIST, currentKey, toEncrypt);
  }

  public setShareOthersExists (currentKey, toEncrypt?){
    this.setItem(LocalStorageProps.SHARE_OTHERS_EXIST, currentKey, toEncrypt);
  }

  public getShareImageExists(toEncrypt?){
    this.getItem(LocalStorageProps.SHARE_IMGEXISTS, toEncrypt);
  }

  public getShareAudiosExists(toEncrypt?){
    this.setItem(LocalStorageProps.SHARE_AUDIOSEXIST, toEncrypt);
  }

  public getShareVideosExists(toEncrypt?){
    this.setItem(LocalStorageProps.SHARE_VIDEOS_EXIST, toEncrypt);
  }

  public getShareOthersExists (toEncrypt?){
    this.setItem(LocalStorageProps.SHARE_OTHERS_EXIST, toEncrypt);
  }

  /*public setUnivShareLinkSessionID(id){
    this.setItem(LocalStorageProps.UNIV_SHARELINK_SESSION_ID,id,false);
  }

  public getUnivShareLinkSessionID(){
    return this.getItem(LocalStorageProps.UNIV_SHARELINK_SESSION_ID,false);
  }

  public removeUnivShareLinkSessionID(){
    this.removeItem(LocalStorageProps.UNIV_SHARELINK_SESSION_ID)
  }

  public setUnivShareLinkPswd(pswd){
    this.setItem(LocalStorageProps.UNIV_SHARELINK_PASSWD,pswd,true);
  }

  public getUnivShareLinkPswd(){
    return this.getItem(LocalStorageProps.UNIV_SHARELINK_PASSWD,true);
  }

  public removeUnivShareLinkPswd(){
    this.removeItem(LocalStorageProps.UNIV_SHARELINK_PASSWD)
  }

  public setUnivShareLinkShareKey(key){
    this.setItem(LocalStorageProps.UNIV_SHARELINK_SHAREKEY,key,false);
  }

  public getUnivShareLinkShareKey(){
    return this.getItem(LocalStorageProps.UNIV_SHARELINK_SHAREKEY,false);
  }

  public removeUnivShareLinkShareKey(){
    this.removeItem(LocalStorageProps.UNIV_SHARELINK_SHAREKEY)
  }

  public setShareLinkCreator(id){
    this.setItem(LocalStorageProps.PUBLIC_LINK_CREATOR,id,false);
  }

  public getShareLinkCreator(){
    return this.getItem(LocalStorageProps.PUBLIC_LINK_CREATOR,false);
  }*/

  public setPeopleTabSortType(data){
    this.setItem(LocalStorageProps.PEOPLE_TAB_SORT_TYPE,data,false);
  }

  public getPeopleTabSortType(){
    return this.getItem(LocalStorageProps.PEOPLE_TAB_SORT_TYPE,false);
  }

  public setPlaceTabSortType(data){
    this.setItem(LocalStorageProps.PLACE_TAB_SORT_TYPE,data,false);
  }

  public getPlaceTabSortType(){
    return this.getItem(LocalStorageProps.PLACE_TAB_SORT_TYPE,false);
  }

  public setStorageProviderType(data){
    this.setItem(LocalStorageProps.STORAGE_PROVIDER_TYPE,data,false);
  }

  public getStorageProviderType(){
    return this.getItem(LocalStorageProps.STORAGE_PROVIDER_TYPE,false);
  }

  public setFolderDataInWhichUploadIsInitiated(data){
    this.setItem(LocalStorageProps.UPLOAD_INITIATED_FOLDER,data,false);
  }


  public getFolderDataInWhichUploadIsInitiated(isEncrypted?:boolean) {
    return this.getItem(LocalStorageProps.UPLOAD_INITIATED_FOLDER,false);
  }

  public setPrivateFolderPassword(data){
    this.setItem(LocalStorageProps.PRIVATE_FOLDER_PASSWORD,data,true);
  }

  public getPrivateFolderPassword(){
    return this.getItem(LocalStorageProps.PRIVATE_FOLDER_PASSWORD,true);
  }

  public setPrivateFolderKey(data){
    this.setItem(LocalStorageProps.PRIVATE_FOLDER_KEY,data,false);
  }

  public getPrivateFolderKey(){
    return this.getItem(LocalStorageProps.PRIVATE_FOLDER_KEY,false);
  }

  

  public removePrivateFolderKey(){
    this.removeItem(LocalStorageProps.PRIVATE_FOLDER_KEY);
  }

  getLocalProperty(key,isEncrypted?:boolean){
    return this.getItem(key, isEncrypted) ;
  }

  setLocalProperty(key,value,isEncrypted?:boolean){
    return this.setItem(key,value, isEncrypted) ;
  }
}






